import qs from 'qs';
import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import Modal, { bemClasses } from 'general/js/modal';
import api, { isHtmlContentType } from 'general/js/api';
import pageSpinner from 'general/js/page-spinner';

export default class ModalTriggerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.targetFromChildren = this.refs.target;
        this.targetSelector = this.element.dataset.target;

        this.modalTarget = null;
        this.modal = null;

        this.modalTarget = this.getFromChildren();
        if (!this.modalTarget) {
            this.modalTarget = this.getFromTarget();
        }

        this.autoOpen = this.element.dataset.autoOpen === 'true' ||
            (this.modalTarget && this.modalTarget.dataset.autoOpen === 'true');

        this.isOpenning = false;
        this.onClick = this.onClick.bind(this);
        this.init();
    }

    init() {
        this.element.addEventListener('click', this.onClick);
    }

    open() {
        if (this.isOpenning) return;

        this.isOpenning = true;
        this.getModal().then((modal) => {
            try {
                modal.open();
                this.isOpenning = false;
                return Promise.resolve();
            } catch (error) {
                return Promise.reject(error);
            }
        }).catch(() => {
            this.isOpenning = false;
        });
    }

    getFromTarget() {
        return document.querySelector(this.targetSelector);
    }

    getFromChildren() {
        return this.targetFromChildren;
    }

    onClick(e) {
        const attr = this.element.getAttribute('data-dc-modal-trigger-cta-in-popup');

        if (attr === null) {
            e.preventDefault();
            if (!app.isEditMode) this.open();
            return;
        }

        const isInsideHeroShort = this.element.closest('.hero--short') !== null;
        const openInPopup = attr.toLowerCase() === 'true';
        if (!openInPopup) return;


        const isMobile = window.innerWidth < 768;

        if (isMobile && isInsideHeroShort) {
            return;
        }


        e.preventDefault();
        if (!app.isEditMode) this.open();
    }


    getModal() {
        if (this.modal === null) {
            return this.getTarget().then((target) => {
                try {
                    this.modal = new Modal(target, {
                        bemList: [bemClasses.MOBILE_FIXED, bemClasses.AUTO]
                    });

                    return Promise.resolve(this.modal);
                } catch (error) {
                    return Promise.reject(error);
                }
            });
        }
        return Promise.resolve(this.modal);
    }

    onDestroy() {
        this.element.removeEventListener('click', this.onClick);
        this.modal = null;
    }

    getAsyncTargetUrl() {
        const targetUrl = this.element.getAttribute('href') || this.getAttribute(this.element, 'href');
        const openInPopupAttribute =
            this.element.getAttribute('data-dc-modal-trigger-cta-in-popup');

        const openInPopup =
            openInPopupAttribute !== null ?
                openInPopupAttribute.toLowerCase() === 'true' :
                null;

        if (targetUrl.indexOf('openPopup') !== -1) return targetUrl;

        if (openInPopup !== null) return openInPopup ? `${targetUrl}?openPopup=true` : targetUrl;

        return `${targetUrl}?openPopup=true`;
    }

    getTarget() {
        if (this.modalTarget) {
            return Promise.resolve(this.modalTarget);
        }

        let asyncTargetUrl = this.getAsyncTargetUrl();

        if (this.options.mergeQueryString && asyncTargetUrl) {
            const qsRegex = /([^\?]+)(\?(.*))?/;
            const parsedTargetUrl = asyncTargetUrl.match(qsRegex);
            const targetQueryString = qs.parse(parsedTargetUrl[3]);
            const locationQueryString = qs.parse(location.search, { ignoreQueryPrefix: true });
            const query = qs.stringify(Object.assign({}, targetQueryString, locationQueryString));

            asyncTargetUrl = parsedTargetUrl[1];

            if (query) {
                asyncTargetUrl += `?${query}`;
            }
        }

        if (!asyncTargetUrl) {
            this.isOpenning = false;
            return Promise.reject();
        }

        if (asyncTargetUrl.indexOf('openPopup') !== -1) {
            pageSpinner.show();

            return api.get(asyncTargetUrl)
                .then((response) => {
                    if (isHtmlContentType(response)) {
                        return response.data;
                    }
                    return Promise.reject(new Error('unknown result from async data'));
                })
                .finally(() => {
                    pageSpinner.hide();
                });
        }

        this.isOpenning = false;
        window.location.assign(asyncTargetUrl);
        return Promise.reject();
    }
}
